import React from 'react';
import ReactDOM from 'react-dom';

import ReservationTriplePicker from '../reservationTriplePicker/reservationTriplePicker.jsx';

var ele = document.getElementById('rtp_div');

ReactDOM.render(
  <ReservationTriplePicker />,
  ele
);
